import React from 'react';
import { useParams } from 'react-router-dom';
import { gql } from '@apollo/client';

import { FullPageSpinner } from 'admin-components/components';
import { useManagedQuery } from 'utils/managedHooks';

export const GET_BOOKING = gql`
  query booking($reference: String!) {
    booking(reference: $reference) {
      reference
      isMultiCurrency
      currency
    }
  }
`;

// eslint-disable-next-line react/display-name
const withBookingCurrency = (Component) => (props) => {
  const { reference } = useParams();
  const { loading, data } = useManagedQuery(GET_BOOKING, {
    variables: { reference }
  });

  if (loading) {
    return <FullPageSpinner />;
  }

  const { booking } = data;

  return <Component {...props} reference={reference} bookingCurrency={booking.currency} isMultiCurrency={booking.isMultiCurrency} />;
};

export default withBookingCurrency;
